import { motion } from "framer-motion";
import { Sparkles, ArrowLeft, Home } from "lucide-react";
import { Link } from "react-router-dom";
import { CURRENCIES } from "@/lib/constants";

export const Header = ({ currency, onCurrencyChange }) => {
  return (
    <header
      className="sticky top-0 z-40 border-b border-[#E8E3D9] bg-[#FBF9F5]/85 backdrop-blur-md"
      data-testid="app-header"
    >
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-between gap-y-3 px-4 sm:px-6 lg:px-10 py-4">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-home-link">
          <div className="h-10 w-10 rounded-xl bg-[#1E2B25] flex items-center justify-center shadow-sm">
            <Sparkles className="h-5 w-5 text-[#D99B26]" strokeWidth={2.2} />
          </div>
          <div className="leading-tight">
            <h1 className="font-heading text-xl font-extrabold tracking-tight text-[#1A231F]">
              My Finanz Planner
            </h1>
            <p className="hidden sm:block text-[11px] text-[#8A9790] font-medium leading-snug max-w-[280px]">
              Personal Finance Tools &amp; Calculators to plan, grow and streamline your personal finance journey
            </p>
          </div>
        </Link>

        <div className="flex items-center gap-2 sm:gap-3">
          <Link to="/" data-testid="home-btn" aria-label="Home"
            className="flex items-center justify-center h-10 w-10 rounded-xl bg-white border border-[#E8E3D9] text-[#1E2B25] hover:bg-[#1E2B25] hover:text-white shadow-sm transition-colors">
            <Home className="h-5 w-5" />
          </Link>
          <Link to="/" data-testid="all-tools-link"
            className="flex items-center gap-2 rounded-full bg-[#1E2B25] text-white px-4 sm:px-5 h-10 text-sm sm:text-base font-bold shadow-sm hover:bg-[#2b3d34] transition-colors">
            <ArrowLeft className="h-4 w-4 sm:h-5 sm:w-5" /> All Tools
          </Link>
          <div
            className="flex items-center gap-1 rounded-full bg-white border border-[#E8E3D9] p-1 shadow-sm"
            data-testid="currency-switcher"
          >
          {Object.values(CURRENCIES).map((c) => {
            const active = c.code === currency;
            return (
              <button
                key={c.code}
                data-testid={`currency-${c.code}`}
                onClick={() => onCurrencyChange(c.code)}
                className={`relative px-3 sm:px-4 py-1.5 rounded-full text-xs sm:text-sm font-semibold transition-colors duration-300 ${
                  active ? "text-white" : "text-[#5C6A64] hover:text-[#1A231F]"
                }`}
              >
                {active && (
                  <motion.span
                    layoutId="currency-pill"
                    className="absolute inset-0 rounded-full bg-[#D96B43]"
                    transition={{ type: "spring", stiffness: 400, damping: 32 }}
                  />
                )}
                <span className="relative flex items-center gap-1.5">
                  <span>{c.flag}</span>
                  <span>{c.code}</span>
                </span>
              </button>
            );
          })}
          </div>
        </div>
      </div>
    </header>
  );
};
